

















import inputMixin from 'library/mixins/input-mixin'
export default

	mixins: [ inputMixin ]

	props:
		options: Array
		name: String
		half: Boolean
		noPill: Boolean
		labelAbove: Boolean
		# Loading state is used in flyout menu
		loading: Boolean

	computed:
		classes: -> [
			'half' if @half
			'no-pill' if @noPill
			'label-padding' if @labelAbove
		]

		labelOption: -> !@labelAbove && !!@label

